import moment from "moment";
import { useMemo } from "react";
import { BuildingModel, CommonFacilityModel } from "src/api/building/building-types";
import { QuotationItem } from "src/api/reservation/reservation-type";
import noImage from "src/assets/images/noImage_default.svg";
import { ResizedImage, Spinner } from "src/components";
import { formatEndTime, getUseTimeDiff, numberToStringWithComma, ViewYmdFormat } from "src/utils/common-util";

type Props = {
  quotation: QuotationItem;
  facility: CommonFacilityModel;
  building: BuildingModel;
};

const QuotationDetail = ({ quotation, facility, building }: Props) => {
  // 부가세
  const VAT_AMOUNT = useMemo(() => {
    let _vat;
    const supplyPrice = quotation?.price;

    _vat = supplyPrice && (supplyPrice * 1.1) / 11;
    return Math.round(Number(_vat));
  }, [quotation]);

  return (
    <>
      {quotation && (
        <>
          <div className="contract-page">
            <article className="" style={{ height: "100%" }}>
              <section className="contract-main">
                <div className="gray-card">
                  <div className="gray-card__product">
                    <ResizedImage
                      className="minmax60"
                      url={
                        facility?.mediaList && facility?.mediaList.length > 0
                          ? facility.mediaList.find((media) => media.isPrimary)?.url || facility?.mediaList![0].url || noImage
                          : noImage
                      }
                      alt={`공용공간 대표 이미지-${facility?.facilityName}`}
                    />
                    <div className="gray-card__contents">
                      <p className="gray-card__contents-title">{facility?.facilityName}</p>
                      <p className="gray-card__contents-address">{building.buildingName}</p>
                    </div>
                  </div>
                  <div className="gray-card__info">
                    <>
                      <div className="base-section-layout-line">
                        <p className="base-section-layout-index text-primary3">이용기간</p>
                        <p className="base-section-layout-value">{`${
                          quotation?.startDate && moment(quotation?.startDate).format(ViewYmdFormat.YYYY_MM_DD)
                        }(${moment(quotation?.startDate).format("ddd")})`}</p>
                      </div>
                      <div className="base-section-layout-line">
                        <p className="base-section-layout-index text-primary3">이용시간</p>
                        <p className="base-section-layout-value">
                          {`${quotation?.startDate && moment(quotation?.startDate).format(ViewYmdFormat.HH_MM)} ~
                      ${formatEndTime(quotation?.endDate)}
                      ${getUseTimeDiff(quotation?.startDate, quotation?.endDate)}`}
                        </p>
                      </div>
                    </>
                  </div>
                </div>
              </section>

              {/* 결제 금액 */}
              <section className="base-section-layout top-divider">
                <div className="base-section-layout__container gap20">
                  <div className="base-section-layout__wrap">
                    <div className="base-section-layout__title-wrap">
                      <h2>결제 금액</h2>
                    </div>
                    <div className="base-section-layout-line">
                      <p className="base-section-layout-index text-primary3">상품금액</p>
                      <p className="base-section-layout-value">{numberToStringWithComma(Number(quotation?.price))}원</p>
                    </div>
                    <div className="base-section-layout-line">
                      <p className="base-section-layout-index text-primary3">부가세</p>
                      <p className="base-section-layout-value">{numberToStringWithComma(VAT_AMOUNT)}원</p>
                    </div>
                    <div className="base-section-layout__wrap">
                      <div className="base-section-layout-line">
                        <p className="base-section-layout-index text-primary3">총 결제 금액</p>
                        <p className="base-section-layout-value font-weight-600">
                          {numberToStringWithComma(Number(quotation?.price) + VAT_AMOUNT)}원
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </article>
          </div>
          <section className="base-section-layout mt30">
            <div className="base-section-layout__wrap ">
              <div className="contents-indicator">
                <Spinner size="page" />
              </div>
              <div className="text-center mt60">
                <h2 className="font18">예약 가능 여부를 확인중입니다.</h2>
                <p className="font15 font-weight-400">잠시만 기다려주세요</p>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};
export default QuotationDetail;
